import { Preferences } from "@capacitor/preferences";
import {useCallback } from 'react';

export function useDeviceStorage() {

    const get = useCallback(async (key: string) => {
      const v = await Preferences.get({ key });
      if (v) {
        return v.value;
      }
      return null;
    }, []);
    
    const set = useCallback(async(key: string, value: string) => {
      if (key){
        await remove(key);
      }
      return Preferences.set({ key, value: value });
    }, []);
    
    const remove = useCallback((key: string) => {
      return Preferences.remove({ key });
    }, []);
    
    const getAll = useCallback(() => {
      return Preferences.keys();
    }, []);
    
    const clear = useCallback(() => {
      return Preferences.clear();
    }, []);

    return {get,set,remove,getAll,clear}


}